var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left.hover",modifiers:{"left":true,"hover":true}}],staticClass:"dot",attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }